
import { defineComponent } from "@vue/runtime-core";
import * as Lang from "@/i18n/lang";

export default defineComponent({
  props: ["locked"],

  methods: {},
});
